import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
const store = new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',
    state: {
      userInfo: {
        folderInfos: [],
        user: {
            username: 'admin',
            userId: '',
            userType: 2
        }
      }
    },
    getters: {
        userHasFolderInfo: state => {
            return state.userInfo.folderInfos
        },
        userType: state => {
            return state.userInfo.user.userType
        },
        userId: state => {
            return state.userInfo.user.userId
        },
        userName: state => {
            return state.userInfo.user.username
        },
        adminAuth: state => {
            return state.userInfo.user.userType === 1
        },
        defaultLevels: state => {
            const folderInfos = state.userInfo.folderInfos
            if (state.userInfo.user.userType !== 1 && folderInfos && folderInfos.length && folderInfos[0].levels) {
                return folderInfos[0].levels
            }
            return '0'
        }
    },
    mutations: {
      setUserInfo (state, payload) {
        state.userInfo = payload
      }
    }
})
export default store